import React from "react"
import WidgetNavigation from "common/components/WidgetNavigation"
import { useSelector } from "react-redux"
import useDimensions from "common/utils/useDimensions"
import { useHistory } from "react-router-dom"
import TopicTable from "../../components/TrendingTopics/TopicTable"
import SortBar from "../../components/TrendingTopics/SortBar"
import config from "../../config"
import { selectSelectedState } from "../../state/reducers/selected-state"
import { ID_STATE_MAP } from "../../constants"
import { useTrendingTopics } from "./TrendingTopicsWidget.data"

const useViews = () => {
  return {
    ratio: {
      id: "ratio",
      label: "News Ratio",
    },
    change: {
      id: "change",
      label: "Daily % Change",
    },
  }
}

const useTopicChart = () => {
  const selectedState = useSelector(selectSelectedState)
  const history = useHistory()

  return topic => {
    const state = ID_STATE_MAP[selectedState]
    history.push(`/${state}/topics/${topic}`)
  }
}

const TrendingTopics = ({ data, maxData, sort, activeView, actions, classes }) => {
  const views = useViews()
  const [ref, { width }] = useDimensions()

  const { isLoading } = useTrendingTopics()

  const handleExpand = useTopicChart()

  const handleViewChange = view => {
    actions.setActiveView(view)
  }

  const handleSortClick = (party, evt) => {
    if (party === sort.party) {
      actions.setSortDir(sort.direction === "ASC" ? "DESC" : "ASC")
    } else {
      actions.setSortParty(party)
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        flexGrow: 1,
      }}
      ref={ref}
    >
      <WidgetNavigation views={views} onChange={handleViewChange} centered />
      <SortBar sort={sort} onClick={handleSortClick} />
      <TopicTable
        data={data}
        loading={isLoading}
        maximums={maxData}
        activeView={activeView}
        classes={classes}
        width={width - 10 - 16}
        onRowClick={config.flags.enableChartIQ ? handleExpand : undefined}
      />
    </div>
  )
}

export default TrendingTopics
